module.exports = __webpack_public_path__ + "static/media/category12.6a7ecc45.png";